import script from "./StaticsticsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./StaticsticsIndex.vue?vue&type=script&setup=true&lang=js"

import "./StaticsticsIndex.vue?vue&type=style&index=0&id=06cb63bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06cb63bd"]])

export default __exports__